import React from 'react'
import {BootstrapSizes} from '../../../defs/defs'
import './EqxForm.css'

interface EqxLabelRowProps {
    label?: string
    value?: string | React.ReactNode
    comment?: string
    error?: string
    or?: string
    children?: React.ReactNode
    isStatic?: boolean
    className?: string
    hasCols?: boolean
    labelSize?: number
    labelSizes?: BootstrapSizes
    fullWidth?: boolean
}
const EqxLabelRow = function (props: EqxLabelRowProps) {
    let labelSizes: BootstrapSizes = {
        default: 4,
    }
    if (props.labelSizes) {
        labelSizes = props.labelSizes
    } else if (props.labelSize) {
        labelSizes = {
            default: props.labelSize,
        }
    }
    let labelClassNames: string = Object.entries(labelSizes)
        .map(([sizeKey, labelSize]) => {
            return 'col-' + sizeKey + '-' + String(labelSize) + ' '
        })
        .join(' ')
    let valueClassNames: string = Object.entries(labelSizes)
        .map(([sizeKey, labelSize]) => {
            return 'col-' + sizeKey + '-' + String(12 - labelSize) + ' '
        })
        .join(' ')
    let isStatic = false
    if (props.hasOwnProperty('value') || props.isStatic) {
        isStatic = true
    }
    let children = props.children ? props.children : props.value
    return (
        <div className={'form-row' + (props.fullWidth ? ' form-row-full' : '')}>
            {props.label && <label className={labelClassNames + ' form-row-label'}>{props.label}</label>}
            <div className={valueClassNames}>
                <div className={props.hasCols ? 'row' : ''}>
                    {isStatic ? (
                        <p className="form-row-input">
                            {children ?? <span className="text-muted">{props.or ?? 'None'}</span>}
                        </p>
                    ) : (
                        children
                    )}
                    {props.comment && <div className="form-help-text">{props.comment}</div>}
                    {props.error && <div className="form-error text-danger">{props.error}</div>}
                </div>
            </div>
        </div>
    )
}
const EqxLabelRows = (props: {children: React.ReactNode; noPadding?: boolean; className?: string}) => {
    return (
        <div
            className={
                'form-rows' + (props.className ? ' ' + props.className : '') + (props.noPadding ? ' no-padding' : '')
            }
        >
            {props.children}
        </div>
    )
}
export {EqxLabelRow as default, EqxLabelRows, type EqxLabelRowProps}
